export const zh = {
  // ===== Tabs =====
  'tab.vps': '实例',
  'tab.billing': '财务',
  'tab.notifications': '通知',
  'tab.tickets': '工单',
  'tab.me': '我的',

  // ===== Common =====
  'common.back': '返回',
  'common.save': '保存',
  'common.delete': '删除',
  'common.cancel': '取消',
  'common.confirm': '确认',
  'common.loading': '加载中…',
  'common.connecting': '连接中…',
  'common.empty': '暂无数据',
  'common.error': '出错了',
  'common.unknown': '未知',
  'common.live': 'LIVE',
  'common.offline': 'OFFLINE',
  'common.dash': '—',
  'common.copy': '复制',
  'common.copied': '已复制',
  'common.connectError': '连接错误',
  'common.justNow': '刚刚',
  'common.minutesAgo': '{n} 分钟前',
  'common.hoursAgo': '{n} 小时前',
  'common.daysAgo': '{n} 天前',

  // ===== Outside Telegram guard =====
  'guard.title': '请在 Telegram 内打开',
  'guard.desc': '这是 Telegram Mini App，需要从 Telegram 客户端的 @neburst_dev_bot 打开。',
  'guard.howTitle': '怎么打开',
  'guard.step1': '在 Telegram 里搜 @neburst_dev_bot',
  'guard.step2': '发 /start，bot 会回一条带按钮的消息',
  'guard.step3': '点 "打开控制台" 按钮即可进入',
  'guard.openBot': '打开 @neburst_dev_bot',

  // ===== Login =====
  'login.title': '登录 Neburst',
  'login.subtitle': '管理你的实例、账单与工单',
  'login.emailPlaceholder': '邮箱',
  'login.passwordPlaceholder': '密码',
  'login.submit': '登录',
  'login.footer.agree': '登录即代表同意',
  'login.footer.tos': 'Neburst 服务条款',
  'login.failed': '登录失败',

  // ===== TOTP =====
  'totp.title': '两步验证',
  'totp.subtitle': '输入身份验证器 App 显示的 6 位数字',
  'totp.placeholder': '••••••',
  'totp.submit': '验证',
  'totp.backToLogin': '返回登录',
  'totp.failed': '验证失败',
  'totp.footer': '如果你使用 Passkey 登录，请到 neburst.com 网页端完成验证',

  // ===== Status =====
  'status.running': '运行中',
  'status.stopped': '已停止',
  'status.starting': '启动中',
  'status.stopping': '关机中',
  'status.rebooting': '重启中',
  'status.creating': '创建中',
  'status.deleting': '删除中',
  'status.error': '异常',
  'status.unknown': '未知',

  // ===== VPS List =====
  'vps.list.title': '我的实例',
  'vps.list.subtitleCount': '{total} 台 · {running} 运行中',
  'vps.list.empty.title': '没有实例',
  'vps.list.empty.desc': '账号下还没有实例',

  // ===== VPS Detail =====
  'vps.detail.network': '网络',
  'vps.detail.realtime': '实时指标',
  'vps.detail.realtimeFooter': '每 15 秒自动刷新（Neburst 端缓存）',
  'vps.detail.cpu': 'CPU',
  'vps.detail.memory': '内存',
  'vps.detail.in': '入站',
  'vps.detail.out': '出站',
  'vps.detail.traffic': '本月流量',
  'vps.detail.power': '电源',
  'vps.detail.power.start': '开机',
  'vps.detail.power.restart': '重启',
  'vps.detail.power.stop': '关机',
  'vps.detail.confirmStop': '确认关机？',
  'vps.detail.confirmForceStop': '强制关机？数据可能丢失',
  'vps.detail.history': '历史趋势',
  'vps.detail.historySoon': '即将上线',
  'vps.detail.historyFooter': 'Phase 2：接入历史图表 / work-request 进度',

  'chart.title': '资源图表',
  'chart.network': '网络',
  'chart.bandwidth': '流量',
  // (label only — chart key kept for stable i18n)
  'chart.footer': '过去 6 小时（带宽为每日累计 GB）',
  'chart.specs': '规格',
  'chart.storage': '存储',

  // ===== Billing =====
  'billing.title': '财务',
  'billing.subtitle': '余额 · 账单 · 流水',
  'billing.balanceLabel': '账户余额',
  'billing.frozen': '冻结',
  'billing.recentInvoices': '最近账单',
  'billing.empty.title': '还没有账单',
  'billing.empty.desc': '充值或开通服务后会出现在这里',
  'billing.tools': '工具',
  'billing.balanceRecords': '余额流水',
  'billing.balanceRecordsDesc': '查看充值、扣费记录',
  'billing.payment': '支付方式 / 自动充值',
  'billing.paymentDesc': '敏感操作请到桌面网页配置',
  'billing.unknownInvoice': '账单',
  'billing.topup': '充值',
  'billing.charge': '消费',
  'billing.showAll': '查看全部 {n} 张',

  // ===== Invoice Detail =====
  'invoice.detail.title': '账单详情',
  'invoice.overview': '概要',
  'invoice.tradeNo': '账单编号',
  'invoice.uuid': 'UUID',
  'invoice.status': '状态',
  'invoice.type': '类型',
  'invoice.amount': '金额',
  'invoice.applied': '已抵扣',
  'invoice.discount': '折扣',
  'invoice.times': '时间',
  'invoice.createdAt': '创建',
  'invoice.expiresAt': '到期',
  'invoice.paidAt': '支付',
  'invoice.footer': '支付/取消等操作请到桌面网页或 neburst.com 完成。',

  // ===== Notifications =====
  'notif.title': '通知',
  'notif.countSuffix': '{n} 条',
  'notif.markAllRead': '全部已读',
  'notif.empty.title': '没有通知',
  'notif.empty.desc': '新的系统消息会出现在这里',
  'notif.fallbackTitle': '通知',

  // ===== Tickets =====
  'tickets.title': '工单',
  'tickets.countSuffix': '{n} 张',
  'tickets.new': '新建',
  'tickets.empty.title': '没有工单',
  'tickets.empty.desc': '遇到问题？点右上角新建一张',
  'tickets.groupOpen': '进行中',
  'tickets.groupClosed': '已关闭',
  'tickets.replies': '{n} 条回复',
  'tickets.statusPending': '待处理',
  'tickets.statusReplied': '已回复',
  'tickets.statusClosed': '已关闭',

  // ===== Ticket Detail =====
  'ticket.detail.fallbackTitle': '工单',
  'ticket.messages': '消息',
  'ticket.noMessages': '暂无消息',
  'ticket.from.staff': '支持人员',
  'ticket.from.ai': 'AI 助手',
  'ticket.from.you': '你',
  'ticket.reply': '回复',
  'ticket.replyPlaceholder': '输入回复内容',
  'ticket.replySubmit': '发送回复',
  'ticket.dept.ai_assistant': 'AI 助手',
  'ticket.dept.compute-instance': '计算 · 实例',
  'ticket.dept.compute_instance': '计算 · 实例',
  'ticket.dept.billing': '财务',
  'ticket.dept.account': '账号',
  'ticket.dept.network': '网络',
  'ticket.dept.general': '一般咨询',
  'ticket.action.create_ticket': '创建工单',
  'ticket.action.close_ticket': '关闭工单',
  'ticket.action.reopen_ticket': '重新打开',
  'ticket.action.mark_processing': '标记处理中',
  'ticket.action.reply_ticket': '已回复',

  // ===== New Ticket =====
  'ticket.new.title': '新建工单',
  'ticket.new.subtitle': '尽量详细描述以加快处理',
  'ticket.new.titlePlaceholder': '标题（简短描述问题）',
  'ticket.new.contentPlaceholder': '详细说明：包含错误截图描述、复现步骤、影响实例等',
  'ticket.new.submit': '提交',

  // ===== Profile =====
  'profile.title': '我的',
  'profile.subtitleLogged': '已登录',
  'profile.nicknameEmpty': '未设置昵称',
  'profile.editNickname': '编辑昵称',
  'profile.alerts': '告警规则',
  'profile.alertsDesc': '流量超阈值自动推送',
  'profile.language': '界面语言',
  'profile.affiliate': '推广',
  'profile.myInvites': '我的邀请',
  'profile.invitesSummary': '{count} 人 · 累计佣金 {commission}',
  'profile.about': '关于',
  'profile.aboutFooter': '安全相关操作（修改密码/2FA/Passkey）请到 neburst.com 桌面端完成。',
  'profile.version': '版本',
  'profile.backend': '后端',
  'profile.logout': '登出',
  'profile.confirmLogout': '确认登出？告警监控会停止。',

  // ===== Alerts =====
  'alerts.title': '告警规则',
  'alerts.subtitle': '超阈值通过 bot 推送',
  'alerts.configured': '已配置',
  'alerts.empty.title': '还没有规则',
  'alerts.empty.desc': '设置一个流量阈值，超过会自动 Telegram 推送',
  'alerts.add': '新增规则',
  'alerts.addFooter': '规则当前作用于所有实例；后续支持单机筛选',
  'alerts.threshold': '阈值',
  'alerts.addSubmit': '添加规则',
  'alerts.cooldown': '冷却 {n}min',
  'alerts.scopeAll': '全部实例',
  'alerts.scopeOne': '单实例',
  'alerts.confirmDelete': '删除这条规则？',

  // ===== Invoice category =====
  'invoice.cat.compute': '计算',
  'invoice.cat.topup': '充值',
  'invoice.cat.service': '服务费',
  'invoice.cat.network': '网络',
  'invoice.cat.storage': '存储',
  'invoice.cat.refund': '退款',

  // ===== Invoice status =====
  'invoice.status.paid': '已支付',
  'invoice.status.unpaid': '待支付',
  'invoice.status.pending': '处理中',
  'invoice.status.partiallyPaid': '部分支付',
  'invoice.status.cancelled': '已取消',
  'invoice.status.failed': '失败',
  'invoice.status.expired': '已过期',

  // ===== Pay cycle / plan =====
  'cycle.monthly': '月付',
  'cycle.quarterly': '季付',
  'cycle.semiAnnually': '半年付',
  'cycle.annually': '年付',
  'cycle.onDemand': '按需',
  'cycle.hourly': '按小时',

  // ===== Instance list =====
  'vps.list.trafficUsed': '已用 {pct}%',

  // ===== Realtime metrics =====
  'vps.detail.linkSpeed': '速率',
  'vps.detail.liveRate': '当前速率',
  'vps.detail.monthlyTraffic': '流量包',
  'vps.detail.updatedAgo': '更新于 {ago}',
  'vps.detail.refresh': '刷新',
  'vps.detail.trafficIn': '入站',
  'vps.detail.trafficOut': '出站',
  'vps.detail.uptime': '已运行',
  'vps.detail.createdAt': '创建',
  'vps.detail.expiresAt': '到期',
  'vps.detail.timesTitle': '时间',
  'chart.live': '带宽',
  'chart.liveBandwidth': '实时带宽',

  'metric.traffic_pct': '流量 %',
  'metric.traffic_gb_used': '流量 GB',
  'metric.instance_down': '下线',
  'metric.expires_in_days': '到期',
  'metric.full.traffic_pct': '流量百分比',
  'metric.full.traffic_gb_used': '已用流量 (GB)',
  'metric.full.instance_down': '实例下线',
  'metric.full.expires_in_days': '剩余到期天数',
} as const;

export type ZhKey = keyof typeof zh;
